import React from 'react'
import PdfViewer from '../components/PdfViewer'
import EventHighlight from '../components/EventHighlight'

function Home() {
  return (
    <div className="page">
      <EventHighlight/>
      <PdfViewer
        url={`${process.env.PUBLIC_URL}/assets/file/Back_to_the_Roots_2025.pdf`}
        title="Programma Back to the Roots 2025"
      />
    </div>
  )
}

export default Home
